module.exports = __webpack_public_path__ + "img/28.0bac9b1c.png";